export default __webpack_public_path__ + "static/media/share.2519d94d.svg";